import { useCallback, useState } from 'react';

import { useHideModal } from './useHideModal';

import { Member, postInviteMembers, postResendInvite } from '@/shared/api/organization';
import { toast } from '@/shared/hooks/useToast';

export enum Action {
    INVITE = 'invite',
    RESEND = 'resend',
}

export const useSendInvites = (action = Action.INVITE) => {
    const { handleCloseModal } = useHideModal();

    const [loading, setLoading] = useState(false);

    const sendInvites = useCallback(
        async ({
            id,
            invites,
            description,
            refresh,
        }: {
            id: number;
            invites: Member[];
            description?: string;
            refresh?: () => void;
        }) => {
            if (!id || !invites || invites.length === 0) return;

            setLoading(true);

            try {
                if (action === Action.INVITE) {
                    await postInviteMembers({ id, body: invites });
                } else if (action === Action.RESEND) {
                    await postResendInvite({ id, body: invites });
                }

                toast({
                    title: 'Invites sent',
                    variant: 'success',
                    description: description || `Successfully sent ${invites.length} invite(s)`,
                });

                handleCloseModal();

                refresh?.();
            } catch (e: any) {
                const message = e?.error?.message || e?.message;

                toast({
                    title: 'Error sending invites',
                    description: message || 'Something went wrong',
                    variant: 'error',
                });
            } finally {
                setLoading(false);
            }
        },
        [],
    );

    return { sendInvites, handleCloseModal, loading };
};
